import { create } from 'zustand'

let initialSelectedProcess = null
export const useSelectedProcess = create((set) => ({
  selectedProcess: initialSelectedProcess,
  setSelectedProcess: (payload) => {
    set({ selectedProcess: payload })
  },
  resetSelectedProcess: () => {
    set({ selectedProcess: null })
  },
}))

let initialFieldsInActivity = []
export const useFieldsInActivity = create((set) => ({
  fieldsInActivity: initialFieldsInActivity,
  setFieldsInActivity: (payload) => {
    set({ FieldsInActivity: payload })
  },
  resetFieldsInActivity: () => {
    set({ FieldsInActivity: initialFieldsInActivity })
  },
}))
